<template>
  <div class="statistics">
    <div class="text">
      <div class="monitor-header">报警信息</div>
      <div class="monitor-text">
        <div class="monitor-select">
          <el-select v-model="warrnType" size="small" clearable placeholder="请选择"
            @change="warrnTypeChange" style="margin-right: 10px">
            <el-option
              v-for="item in warrnTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="warnTime" size="small" clearable placeholder="请选择" @change="warrnTypeChange">
            <el-option
                v-for="item in warnTimeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="monitor-table">
          <el-table :data="tableData" border :header-cell-style="tableTouStyle" max-height="450">
            <el-table-column align="center" label="序号"  type="index" width="60"/>
            <el-table-column align="center" label="报警种类" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.warningType === '6'">紧急报警</span>
                <span v-if="scope.row.warningType === '2' || scope.row.warningType === '11'">超员报警</span>
                <span v-if="scope.row.warningType === '1'">禁区报警</span>
                <span v-if="scope.row.warningType === '3' || scope.row.warningType === '4' || scope.row.warningType === '5' || scope.row.warningType === '15'">区域报警</span>
                <span v-if="scope.row.warningType === '7' || scope.row.warningType === '16'">电子围栏报警</span>
                <span v-if="scope.row.warningType === '13' || scope.row.warningType === '17' || scope.row.warningType === '18' || scope.row.warningType === '19'">车辆报警</span>
                <span v-if="scope.row.warningType === '14'">低电量报警</span>
                <span v-if="scope.row.warningType === '8'">离岗报警</span>
                <span v-if="scope.row.warningType === '20'">门禁报警</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="areaName" label="报警区域" width="180"/>
            <el-table-column align="center" prop="name" label="时间" width="180">
              <template slot-scope="scope">
                <span>{{ timestampToTime(scope.row.warningtime) }}~{{timestampToTime(scope.row.warnendtime) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="内容">
              <template slot-scope="scope">
                <div v-if="scope.row.warningType === '1'">
                  <span>{{ scope.row.name }}：</span>
                  <span>禁区闯入</span>
                </div>
                <div v-if="scope.row.warningType === '2'">
                  <span>{{ scope.row.name }}：</span>
                  <span>区域超员</span>
                </div>
                <div v-if="scope.row.warningType === '3'">
                  <span>{{ scope.row.name }}：</span>
                  <span>区域超时滞留</span>
                </div>
                <div v-if="scope.row.warningType === '4'">
                  <span>{{ scope.row.name }}：</span>
                  <span>进入区域过短</span>
                </div>
                <div v-if="scope.row.warningType === '5'">
                  <span>{{ scope.row.name }}：</span>
                  <span>区域静止过长</span>
                </div>
                <div v-if="scope.row.warningType === '6'">
                  <span>{{ scope.row.name }}：</span>
                  <span>SOS</span>
                </div>
                <div v-if="scope.row.warningType === '7'">
                  <span>{{ scope.row.name }}：</span>
                  <span>围栏闯入报警</span>
                </div>
                <div v-if="scope.row.warningType === '8'">
                  <span>{{ scope.row.name }}：</span>
                  <span>围栏离岗报警</span>
                </div>
                <div v-if="scope.row.warningType === '11'">
                  <span>{{ scope.row.name }}：</span>
                  <span>操作工超员</span>
                </div>
                <div v-if="scope.row.warningType === '13'">
                  <span>{{ scope.row.name }}：</span>
                  <span>车辆超速</span>
                </div>
                <div v-if="scope.row.warningType === '14'">
                  <span>{{ scope.row.name }}：</span>
                  <span>低电量报警</span>
                </div>
                <div v-if="scope.row.warningType === '15'">
                  <span>{{ scope.row.name }}：</span>
                  <span>缺员报警</span>
                </div>
                <div v-if="scope.row.warningType === '16'">
                  <span>{{ scope.row.name }}：</span>
                  <span>串岗报警</span>
                </div>
                <div v-if="scope.row.warningType === '17'">
                  <span>{{ scope.row.name }}：</span>
                  <span>车辆线路偏移</span>
                </div>
                <div v-if="scope.row.warningType === '18'">
                  <span>{{ scope.row.name }}：</span>
                  <span>违规停车</span>
                </div>
                <div v-if="scope.row.warningType === '19'">
                  <span>{{ scope.row.name }}：</span>
                  <span>车辆超时滞留</span>
                </div>
                <div v-if="scope.row.warningType === '20'">
                  <span>{{ scope.row.name }}：</span>
                  <span>门禁越界报警</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="success">处理</el-button>
                <!-- @click="disposeClick(scope.row.id)" -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog title="处理意见" :visible.sync="dialogVisible" width="30%" label-width="80px">
      <el-form ref="form" :model="form" :rules="rules" :inline="true" >
        <el-form-item label="处理意见:" prop="confirmOpinion">
          <el-input v-model="form.confirmOpinion" type="textarea" :rows="5" placeholder="请输入处理意见" style="width: 100%;" resize="none" />
        </el-form-item>
      </el-form >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmOpinionClick">确 定</el-button>
      </span>
    </el-dialog>
    <audio style="display: none;" autoplay src="@/assets/audio/alarm_sound.mp3" controls="controls" ref='audios'></audio>
  </div>
</template>

<script>
import { getPolice, getConfirmOpinion } from "@/api/worker.js"
import MapUtil from "@/views/control/map/util/mapUtil";
import CONSTANTS from "@/views/control/map/constants";
// import {getChannelrecord} from "@/api/BoxData";

export default {
  name: "Gaojing",
  data() {
    return {
      drawer: true,
      activeName: "1",
      totalNum: null,
      pageNum: 1,
      pageSize: 10,
      warrnType: null,
      warnTime:1,//1天
      username: this.D3Config.username,
      password: this.D3Config.password,
      warnTimeList:[
        {
          value: 1,
          label: '1天'
        },
        {
          value: 2,
          label: '2天'
        },
        {
          value: 3,
          label: '3天'
        },
        {
          value: 4,
          label: '4天'
        },
        {
          value: 5,
          label: '5天'
        },
        {
          value: 6,
          label: '6天'
        },
        {
          value: 7,
          label: '7天'
        }
      ],
      warrnTypeList: [
        {
          value: 1,
          label: '禁区闯入'
        },
        {
          value: 2,
          label: '区域超员'
        },
        {
          value: 3,
          label: '区域超时滞留'
        },
        {
          value: 4,
          label: '进入区域过短'
        },
        {
          value: 5,
          label: '区域静止过长'
        },
        {
          value: 6,
          label: 'SOS'
        },
        {
          value: 7,
          label: '围栏闯入报警'
        },
        {
          value: 8,
          label: '围栏离岗报警'
        },
        {
          value: 11,
          label: '操作工超员'
        },
        {
          value: 13,
          label: '车辆超速'
        },
        {
          value: 14,
          label: '低电量报警'
        },
        {
          value: 15,
          label: '缺员报警'
        },
        {
          value: 16,
          label: '串岗报警'
        },
        {
          value: 17,
          label: '车辆线路偏移'
        },
        {
          value: 18,
          label: '违规停车'
        },
        {
          value: 19,
          label: '车辆超时滞留'
        },
        {
          value: 20,
          label: '门禁越界报警'
        }
      ],

      dialogVisible: false,
      dialogId: '',
      form: {
        confirmOpinion: ''
      },
      rules: {
        confirmOpinion: [
          { required: true, message: '请输入处理意见', trigger: 'blur' }
        ]
      },

      // 表格头部样式
      tableTouStyle: {
        background: '#f1f1f1',
        color: '#000',
        'font-size': '14px',
        'text-align': 'center'
      },
      tableData: []
    };
  },
  props: {
    msg: String,
  },
  created() {
    this.getListData()
  },
  mounted() {
    // let alarmLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.ALARM);
    // this.wranInterval = setInterval(() => {
    //   getPolice(this.username, this.password,this.warrnType,1).then(res => {
    //     if (res.data.data.length > 0) {
    //       this.$refs.audios.play();
    //       alarmLayer.addEntities(res.data.data,this.$refs.boxer.allBoxEntitys);
    //     }
    //   });
    // }, 10000)
  },
  methods: {
    // 提交处理意见
    confirmOpinionClick() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        getConfirmOpinion(this.username, this.password,this.form.confirmOpinion).then(res => {
          const result = res.data
          if (result.status === 1) {
            this.$message.error(result.msginfo)
          } else {
            this.$message.success(result.msginfo)
            this.getListData()
          }
        })
      })
    },
    //处理按钮
    disposeClick(id) {
      this.dialogId = id
      this.form.confirmOpinion = ''
      this.dialogVisible = true
    },
    // 处理列表的时间戳
    timestampToTime(cjsj) {
      var date = new Date(cjsj) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      var D = date.getDate() + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s = date.getSeconds()
      return Y+M+D+h+m+s
    },
    // 下拉框变化请求数据
    warrnTypeChange(val) {

      this.getListData()
    },
    //获取数据
    getListData() {
      getPolice(this.username, this.password,this.warrnType,this.warnTime).then(res => {
        const result = res.data
        this.tableData = result.data
      })
    },
    // 子组件传给父组件的分页参数
    chileByCurrentPage(val) {
      this.$nextTick(function() {
        this.pageNum = val
      })
    }
  },
};
</script>

<style scoped>
.statistics {
  width: 1140px;
  height: 660px;
  position: absolute;
  top: 15%;
  left: 20%;
}
.text {
  width: 100%;
  height: 100%;
  color: #000;
  background: #fff;
}
.monitor-text{
  height: calc(100% - 40px);
  padding: 0 20px 0 20px;
}
.monitor-header {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #f5f5f5;
}
.monitor-select{
  height: 60px;
  padding: 10px 0 10px 0;
}
.monitor-table {
  width: 100%;
  height: calc(100% - 120px);
}
/deep/ .el-button--success{
  background-color: green;
  border-color: green;
}
/deep/.el-dialog {
  margin-top: 300px !important;
  width: 780px;
  background: #ffffff;
  border-radius: 2px;
}
/deep/.el-dialog__header {
  height: 40px;
  background: #f5f5f5;
  padding: 0;
  text-align: center;
  line-height: 40px;
}
.el-dialog__title {
  line-height: 40px;
  color: #333333;
  font-size: 16px;
  font-weight: 500;
}
/deep/ .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
}
/deep/ .el-form-item{
  width: 100%;
}
/deep/ .el-form-item__content{
  width: calc(100% - 100px);
}
</style>